var map = {
	"./add-equipment.svg": "5946",
	"./analysis.svg": "e15b",
	"./arrow_left.svg": "4db9",
	"./btn_add.svg": "5726",
	"./card_benifit_icon1.svg": "26a2",
	"./card_benifit_icon2.svg": "86a5",
	"./card_benifit_icon3.svg": "3b75",
	"./card_benifit_icon4.svg": "7a0e",
	"./card_benifit_icon5.svg": "d6a5",
	"./card_benifit_icon6.svg": "0aee",
	"./card_order.svg": "a6b1",
	"./cart_icon_del.svg": "d878",
	"./cart_icon_more_grey.svg": "81c7",
	"./company_identification.svg": "a5e2",
	"./customer.svg": "b17f",
	"./detail_bind_list.svg": "5250",
	"./detail_my_equipement.svg": "2b60",
	"./download.svg": "4dae",
	"./drug_order.svg": "68e4",
	"./edit_icon_pencil.svg": "762a",
	"./ellipsis_left.svg": "d99f",
	"./ellipsis_right.svg": "6f50",
	"./equipment.svg": "b596",
	"./examination.svg": "0cc5",
	"./examination_finish.svg": "ea3a",
	"./examination_pay.svg": "0b41",
	"./examination_reserve.svg": "20a1",
	"./examination_wait.svg": "32f0",
	"./global_btn_top.svg": "64d6",
	"./global_icon_add.svg": "61fd",
	"./global_icon_back.svg": "fbfd",
	"./global_icon_cart.svg": "a915",
	"./global_icon_cart_white.svg": "0404",
	"./global_icon_collect_nor.svg": "4ea5",
	"./global_icon_del.svg": "d71d",
	"./global_icon_drug_cart.svg": "eaef",
	"./global_icon_edit.svg": "4d3b",
	"./global_icon_gou.svg": "0a8d",
	"./global_icon_home.svg": "bbe4",
	"./global_icon_hot.svg": "89bd",
	"./global_icon_like.svg": "1bf2",
	"./global_icon_mine.svg": "cb80",
	"./global_icon_more.svg": "139c",
	"./global_icon_remind.svg": "9e8f",
	"./global_icon_service.svg": "23ef",
	"./global_icon_welfare.svg": "18c4",
	"./goods_icon_warning.svg": "acb4",
	"./group_del.svg": "7d95",
	"./group_edit.svg": "9db1",
	"./health-right.svg": "9ac9",
	"./health_moniter.svg": "0928",
	"./health_report.svg": "4af5",
	"./home-vip-qy-1.svg": "0ae9",
	"./home-vip-qy-2.svg": "b87c",
	"./home-vip-qy-3.svg": "3381",
	"./home-vip-qy-4.svg": "1200",
	"./home-vip-qy-5.svg": "2f11",
	"./home-vip-qy-6.svg": "97d7",
	"./home_icon_10.svg": "bf28",
	"./home_icon_change.svg": "0861",
	"./home_icon_message.svg": "b22d",
	"./home_icon_search.svg": "0663",
	"./home_icon_service.svg": "a1b3",
	"./home_img_1.svg": "3cf1",
	"./home_img_2.svg": "1b66",
	"./home_live_icon_like.svg": "6e5c",
	"./icon-add.svg": "b10a",
	"./icon-gift.svg": "2e54",
	"./icon-grafic-code.svg": "ed4f",
	"./icon-lock.svg": "cbf8",
	"./icon-phone-number.svg": "240e",
	"./icon_add.svg": "c49e",
	"./icon_add_blue.svg": "883d",
	"./icon_add_white.svg": "733a",
	"./icon_addmanually.svg": "24f1",
	"./icon_arrow_black.svg": "87a3",
	"./icon_arrow_down.svg": "f3c8",
	"./icon_arrow_lef.svg": "bc0e",
	"./icon_arrow_lef_invite.svg": "8e0d",
	"./icon_arrow_presure.svg": "75b5",
	"./icon_arrow_rig.svg": "cbbe",
	"./icon_arrow_rig_black.svg": "e0c7",
	"./icon_arrow_rig_gray.svg": "75a8",
	"./icon_arrow_rig_red.svg": "203b",
	"./icon_arrow_right.svg": "4f0b",
	"./icon_arrow_right_white.svg": "82de",
	"./icon_arrow_sugar.svg": "331e",
	"./icon_arrow_up.svg": "fa44",
	"./icon_arrow_white.svg": "f3a9",
	"./icon_attention.svg": "a2b4",
	"./icon_bind.svg": "b0b0",
	"./icon_bmi.svg": "aec2",
	"./icon_card.svg": "bfba",
	"./icon_card_order.svg": "b9e9",
	"./icon_cart.svg": "b6f0",
	"./icon_chest.svg": "fece",
	"./icon_close.svg": "8c68",
	"./icon_coll.svg": "20f9",
	"./icon_collect_nor.svg": "d143",
	"./icon_collect_per.svg": "960a",
	"./icon_comp.svg": "ce3a",
	"./icon_coo.svg": "12d6",
	"./icon_del.svg": "7861",
	"./icon_edit.svg": "fdc3",
	"./icon_equipment.svg": "4107",
	"./icon_fam.svg": "4dfc",
	"./icon_family_ask.svg": "6cea",
	"./icon_headset.svg": "f325",
	"./icon_heart.svg": "904e",
	"./icon_height.svg": "f929",
	"./icon_help.svg": "70c6",
	"./icon_help_v2.svg": "53eb",
	"./icon_hip.svg": "3f75",
	"./icon_his.svg": "9fbe",
	"./icon_history.svg": "1838",
	"./icon_inquiry.svg": "e146",
	"./icon_invite.svg": "16b3",
	"./icon_logDrug.svg": "83cd",
	"./icon_more.svg": "6a53",
	"./icon_msg.svg": "e66f",
	"./icon_news.svg": "566d",
	"./icon_pay_weixin.svg": "7f00",
	"./icon_pressure.svg": "9329",
	"./icon_private_agreement.svg": "2403",
	"./icon_pyq.svg": "d7b1",
	"./icon_qq.svg": "bf49",
	"./icon_qz.svg": "9805",
	"./icon_restart.svg": "be85",
	"./icon_sel.svg": "8cb3",
	"./icon_ser.svg": "9e04",
	"./icon_service.svg": "fb00",
	"./icon_setting.svg": "bbf2",
	"./icon_share.svg": "87c3",
	"./icon_sift.svg": "2488",
	"./icon_star_none.svg": "09b2",
	"./icon_star_sel.svg": "a225",
	"./icon_stature.svg": "c733",
	"./icon_sugar.svg": "a1de",
	"./icon_swiper_next.svg": "9538",
	"./icon_swiper_prev.svg": "e1b5",
	"./icon_temp.svg": "400b",
	"./icon_triangle.svg": "711a",
	"./icon_update.svg": "330b",
	"./icon_uric.svg": "2849",
	"./icon_uric2.svg": "9192",
	"./icon_user_agreement.svg": "91a2",
	"./icon_waist.svg": "773f",
	"./icon_wechat.svg": "f74d",
	"./icon_weight.svg": "32fd",
	"./icon_weight_2.svg": "f220",
	"./img1.svg": "7520",
	"./img2.svg": "20c3",
	"./img_bmi.svg": "df23",
	"./img_data_blue.svg": "3e81",
	"./img_data_red.svg": "2f118",
	"./img_ent.svg": "b61f",
	"./inquiry_order.svg": "d795",
	"./introduce.svg": "94f8",
	"./mall_icon_arrow_down.svg": "2b6d",
	"./mall_order.svg": "0c14",
	"./mine_icon_adr.svg": "5b99",
	"./mine_icon_cart.svg": "2737",
	"./mine_icon_comp.svg": "0b39",
	"./mine_icon_drug.svg": "6c18",
	"./mine_icon_examination.svg": "fdaa",
	"./mine_icon_file.svg": "0e1e",
	"./mine_icon_foot.svg": "1774",
	"./mine_icon_help.svg": "b8b5",
	"./mine_icon_inquiry.svg": "7afd",
	"./mine_icon_like.svg": "12c0",
	"./mine_icon_list.svg": "f42c",
	"./mine_icon_love.svg": "e7e4",
	"./mine_icon_report.svg": "f11e",
	"./mine_icon_vip1.svg": "5ba8",
	"./mine_icon_vip2.svg": "b403",
	"./mine_img_doctor.svg": "aec1",
	"./mine_img_shadow.svg": "a060",
	"./mine_order_1.svg": "2c33",
	"./mine_order_2.svg": "47a3",
	"./mine_order_3.svg": "0221",
	"./mine_order_4.svg": "1be8",
	"./mine_order_5.svg": "c6dc",
	"./my_group.svg": "2b68",
	"./not_vip_identification.svg": "33fc",
	"./order_icon_arrow1.svg": "18dc",
	"./order_icon_fold_up.svg": "d729",
	"./order_icon_pen.svg": "18a9",
	"./order_icon_safe.svg": "d9a5",
	"./order_icon_time.svg": "3734",
	"./order_icon_van.svg": "e502",
	"./order_pop_icon_error.svg": "d186",
	"./order_pop_icon_point.svg": "6288",
	"./orderdetails_icon_location.svg": "7a82",
	"./patent.svg": "59d2",
	"./project-agent/icon_add.svg": "beeb",
	"./project-agent/icon_arrow_down.svg": "47fe",
	"./project-agent/icon_arrow_lef_v2.svg": "3a34e",
	"./project-agent/icon_arrow_rig.svg": "9159",
	"./question.svg": "ae00",
	"./qy-right.svg": "03fe",
	"./qy_1.svg": "dd09",
	"./qy_2.svg": "2428",
	"./qy_3.svg": "e921",
	"./qy_4.svg": "cdc5",
	"./qy_5.svg": "0159",
	"./qy_6.svg": "035a",
	"./qy_7.svg": "ce54",
	"./radio_active.svg": "3297",
	"./radio_checked.svg": "ac33",
	"./radio_default.svg": "e66a",
	"./radio_no_checked.svg": "d152",
	"./radio_sel.svg": "8a8e",
	"./rec_doc1.svg": "d1a8",
	"./rec_doc2.svg": "e737",
	"./relation.svg": "f8d1",
	"./setting.svg": "05ff",
	"./tabbar_icon_ent_def.svg": "ad08",
	"./tabbar_icon_heal_def.svg": "2efd",
	"./tabbar_icon_heal_def1.svg": "8342",
	"./tabbar_icon_heal_sel.svg": "3b70",
	"./tabbar_icon_heal_sel1.svg": "9524",
	"./tabbar_icon_home_def.svg": "d9ec",
	"./tabbar_icon_home_def1.svg": "604d",
	"./tabbar_icon_home_sel.svg": "2fb0",
	"./tabbar_icon_home_sel1.svg": "2958",
	"./tabbar_icon_mine_def.svg": "1581",
	"./tabbar_icon_mine_def1.svg": "bbfe",
	"./tabbar_icon_mine_sel.svg": "b1c8",
	"./tabbar_icon_mine_sel1.svg": "8ceb",
	"./tabbar_icon_shop_def.svg": "2740",
	"./tabbar_icon_shop_def1.svg": "896f",
	"./tabbar_icon_shop_sel.svg": "6d6d",
	"./tabbar_icon_shop_sel1.svg": "42a4",
	"./tabbar_icon_sort_def.svg": "50cc",
	"./tabbar_icon_sort_sel.svg": "392a",
	"./tabbar_icon_tuanjian_sel.svg": "916a",
	"./tag_three.svg": "a33f",
	"./test-del.svg": "bed6",
	"./toggle.svg": "510c",
	"./video_icon_like.svg": "ff1a",
	"./video_icon_play.svg": "0f2c",
	"./vip-hot.svg": "f0e5",
	"./vip-super.svg": "de14",
	"./vip.svg": "1296",
	"./vip_identification.svg": "6467",
	"./weight_down.svg": "c650",
	"./weight_up.svg": "9794",
	"./welfare_icon_cart.svg": "7fe5",
	"./welfare_live_icon_like.svg": "0d87",
	"./zhenai_home_def.svg": "4784",
	"./zhenai_home_sel.svg": "0e82",
	"./zhenai_my_def.svg": "5956",
	"./zhenai_my_sel.svg": "6507"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9e81";